import React, { useEffect } from 'react';
import './PricingModal.css';

const tiers = [
  {
    id: 'starter',
    name: 'Starter',
    price: '£29',
    period: '/month',
    description: 'For sole traders and freelancers getting started.',
    features: [
      '1 user license',
      'Up to 100 transactions/month',
      'AI receipt capture, tax categorisation & HMRC-compliant storage',
      'AI cash flow forecast',
      'AI deadline alerts',
      'Customer invoicing with automated chasing function',
      'MTD-compatible VAT & Self Assessment filing',
    ],
    cta: 'Sign Up',
    highlight: false,
  },
  {
    id: 'growth',
    name: 'Growth',
    price: '£79',
    period: '/month',
    description: 'For growing small businesses that need the full picture.',
    features: [
      'Up to 10 user licenses',
      'Unlimited transactions',
      'AI receipt capture, tax categorisation & HMRC-compliant storage',
      'AI cash flow forecast',
      'AI deadline alerts',
      'Customer invoicing with automated chasing function',
      'MTD-compatible VAT & Self Assessment filing',
      'Expense approval workflow with company hierarchy',
      'Priority support',
    ],
    cta: 'Sign Up',
    highlight: true,
  },
  {
    name: 'Enterprise',
    price: 'Custom',
    period: '',
    description: 'Custom infrastructure and dedicated support.',
    features: [
      '25+ user licenses',
      'Unlimited transactions',
      'AI receipt capture, tax categorisation & HMRC-compliant storage',
      'AI cash flow forecast',
      'AI deadline alerts',
      'Customer invoicing with automated chasing function',
      'MTD-compatible VAT & Self Assessment filing',
      'Expense approval workflow with company hierarchy',
      'Priority support',
    ],
    cta: 'Contact Us',
    highlight: false,
    contactLink: true,
  },
];

const PricingModal = ({ onClose }) => {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  return (
    <div className="prmodal-backdrop" onClick={onClose}>
      <div className="prmodal-panel" onClick={(e) => e.stopPropagation()}>
        <button className="prmodal-close" onClick={onClose} aria-label="Close">✕</button>

        <div className="prmodal-header">
          <p className="prmodal-eyebrow">Pricing</p>
          <h2 className="prmodal-title">Simple, transparent pricing</h2>
          <p className="prmodal-subtitle">
            No hidden fees. Cancel any time. All plans include a 14-day free trial.
          </p>
        </div>

        <div className="prmodal-tiers">
          {tiers.map((tier) => (
            <div className={`prmodal-tier ${tier.highlight ? 'prmodal-tier--featured' : ''}`} key={tier.name}>
              <span className={`prmodal-badge ${tier.highlight ? '' : 'prmodal-badge--hidden'}`}>Most Popular</span>
              <p className="prmodal-tier-name">{tier.name}</p>
              <div className="prmodal-price-row">
                <span className="prmodal-price">{tier.price}</span>
                {tier.period && <span className="prmodal-period">{tier.period}</span>}
              </div>
              <p className="prmodal-tier-desc">{tier.description}</p>
              <ul className="prmodal-features">
                {tier.features.map((f) => (
                  <li key={f}>
                    <span className="prmodal-check">✓</span>
                    {f}
                  </li>
                ))}
              </ul>
              {tier.contactLink ? (
                <a
                  href="mailto:leon.franzke@arcadeus.ai"
                  className={`prmodal-cta ${tier.highlight ? 'prmodal-cta--featured' : ''}`}
                >
                  {tier.cta}
                </a>
              ) : (
                <button
                  className={`prmodal-cta ${tier.highlight ? 'prmodal-cta--featured' : ''}`}
                  onClick={() => window.open(`https://app.arcadeus.ai/?mode=signup&plan=${tier.id}`, '_blank')}
                >
                  {tier.cta}
                </button>
              )}
            </div>
          ))}
        </div>

        <p className="prmodal-note">
          All prices exclude VAT. Early access members lock in founding member rates permanently.
        </p>

      </div>
    </div>
  );
};

export default PricingModal;
